export enum DeduplicationSetting {
  On = 'ON',
  Off = 'OFF',
  Verify = 'VERIFY',
  Inherit = 'INHERIT',
}
